import { Box, Typography, useTheme } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"

import { hexToRGB, rgbToString } from "../../../helpers/utils/colors"
// BQ26: Comment out unused imports - sign-up functionality removed
// import LocalStorageKeys from "../../../types/LocalStorageKeys"
// import { Route, STRAPI_URL } from "../../../router"
import { Route } from "../../../router"
// import { MyInfoReason } from "../../../types/MyInfoUserData"
// import { MembershipType } from "../../../types/MembershipType"
// import { domainCheckMembershipType } from "../../../helpers/utils/common"
// BQ26: Comment out unused sign-up button imports - sign-up buttons removed
// import SignUpButton from "../../atoms/SignUpButton/SignUpButton"
// import ActivateMembershipButton from "../../atoms/ActivateMembershipButton/ActivateMembershipButton"
// BQ26: Comment out unused imports - sign-up functionality removed
// import { useContext } from "react"
// import { UserContext } from "../../../stores/User/UserStore"
import useGoogleTagManager from '../../../helpers/analytics/use-google-tag-manager'
import GtmEventName from '../../../helpers/analytics/GtmEventName'

import styles from "./LandingFooter.module.scss"
import LoginButton from "../../atoms/LoginButton/LoginButton"
import Spacer from "../../atoms/Spacer/Spacer"

// BQ26: Comment out unused constant - sign-up functionality removed
// const UNION_SIGNUP_URL = process.env.REACT_APP_UNION_SIGNUP_URL ?? `https://www.ntuc.org.sg/Uportal/Home/Memberships/Become%20a%20member`

const LandingFooter = () => {
    const { t } = useTranslation()

    const navigate = useNavigate()
    const { trackButtonClick } = useGoogleTagManager()

    const { palette } = useTheme()
    // BQ26: Comment out unused userState - sign-up buttons removed
    // const { state: userState } = useContext(UserContext)

    // BQ26: Comment out unused variables - sign-up buttons removed
    // const membershipTypeFromDomainName = domainCheckMembershipType()
    // const partner = userState.partner?.data

    // BQ26: Comment out unused handleSignUpButtonClick - sign-up buttons removed
    /*
    const handleSignUpButtonClick = () => {
        trackButtonClick(GtmEventName.SIGN_UP_CLICK, `Landing footer sign up button`)

        if (membershipTypeFromDomainName === MembershipType.UPME) {
            window.location.replace(UNION_SIGNUP_URL)
        } else {
            localStorage.setItem(LocalStorageKeys.MYINFO_REASON, MyInfoReason.SIGNUP)
            window.location.href = `${STRAPI_URL}${Route.MYINFO_AUTHORISE}`
        }
    }
    */

    const handleLoginButtonClick = () => {
        trackButtonClick(GtmEventName.SIGN_IN_CLICK, `Landing footer sign in button`)
        navigate(Route.PLS_LOGIN)
    }

    const handleFindOutMoreButtonClick = () => {
        window.open(`https://youngntuc.org.sg/starter#pwa`, `_blank`, `noopener,noreferrer`)
    }

    const endColorRgb = hexToRGB(palette.surface.secondary.dark)
    endColorRgb.a = 0.9

    const footerStyle = {
        background: `linear-gradient(180deg, ${palette.surface.secondary.main} 0%, ${rgbToString(endColorRgb)} 100%)`,
    }

    return (
        <Box className={styles.landingFooter} sx={footerStyle}>
            <Box className={styles.subtitle}>
                <Typography variant="subtitle2" color='primary' mb={1}>{t(`landing_page_footer_offer`)}</Typography>
            </Box>
            <Box className={styles.actionBox}>
                {/* BQ26: Comment out sign-up buttons - disable sign-up functionality
                {
                    partner ?
                        <ActivateMembershipButton onClick={handleSignUpButtonClick} fullWidth /> :
                        <SignUpButton onClick={handleSignUpButtonClick} fullWidth />
                }
                <Spacer height={10}/>
                */}
                <LoginButton onClick={handleLoginButtonClick} fullWidth />
            </Box>
            <Box>
                <Spacer height={10}/>
                <Typography className={styles.link} onClick={handleFindOutMoreButtonClick}>{t(`landing_page_find_out_more`)}</Typography>
            </Box>
        </Box>
    )
}

export default LandingFooter